<template>
    <BModal :model-value="modal" scrollable centered title="Accommodation" @update:modelValue="updateModal">
    <template #header>
            <div class="d-flex align-items-center justify-content-between modal-title w-100">
                <h5 class="">Accommodation</h5>
            </div>
            <BButton
                variant="link"
                class="close"
                @click="$emit('updateModal', false)"
            >
                <i class="ion ion-android-close"></i>
            </BButton>
        </template>

        <BForm>
            <BContainer>
                
                <BRow class="mb-3">
                    <BCol>
                        <BFormSelect v-model="optionDestination.selected" :options="optionDestination.data"></BFormSelect>
                    </BCol>
                    
                </BRow>

                <BRow>
                    <BCol>
                        <BFormInput type="text" id="input-1" v-model="contact" :state="state" placeholder="Hotel Name" class="form-group"></BFormInput>
                    </BCol>
                    <BCol>
                        <BFormInput type="text" id="input-1" v-model="contact" :state="state" placeholder="Hotel Code" class="form-group" />
                    </BCol>
                </BRow>

                <BRow class="mb-3">
                    <BCol>
                        <BFormInput type="number" placeholder="Pax"></BFormInput>
                    </BCol>
                    <BCol>
                        <BFormCheckbox 
                            value="yes"
                            unchecked-value="no"
                            class="ml-1"
                            >Extra Bed
                        </BFormCheckbox>
                    </BCol>
                    
                </BRow>
                <BRow>
                    <BCol class="d-flex">
                        <BFormInput type="number" placeholder="Price"></BFormInput>
                    </BCol>
                </BRow>

            </BContainer>
            
                
        
        </BForm>
        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary"  class="mr-2">Save</BButton>
                <BButton variant="danger" @click="$emit('updateModal', false)">Cancel</BButton>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal,BRow, BCol, BForm, BFormInput, BButton, BFormSelect, BFormCheckbox } from 'bootstrap-vue-next';
import { ref,reactive,} from 'vue'

export default{
    name : 'AccommodationForm',
    components : { BModal,BRow, BCol, BForm, BFormInput, BButton, BFormSelect, BFormCheckbox },
    props : {
        modal: Boolean,
    },
    setup(props, { emit }){

        const optionDefault = ref('')
        const optionDestination = reactive({
            selected : '-',
            data : [
                {value : '-', text : 'Choose Destination'},
                {value : 'MDN', text : 'MDN'},
                {value : 'BKL', text : 'BKL'},
            ]
        })
        const optionHotel = reactive({
            selected : '-',
            data : [
                {value : '-', text : 'Choose Hotel'},
                {value : 'HDR', text : 'Hotel Deli River'},
                {value : 'ECO', text : 'Eco Hotel'},
                {value : 'new', text : 'Add new Hotel'},
            ]
        })
        const updateModal = (value) => {
            emit("update:modal", value); // Sync modal state with parent
        };
        return { 
            optionDefault,
            optionDestination,
            optionHotel,
            updateModal
         }
    }
}

</script>

